import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

export { application }

// Turbo.setConfirmMethod((message, element) => {
// 	if (window.confirm(message)) {
// 		const hiddenField = element.querySelector("input[type='hidden']")

// 		if (hiddenField) {
// 			const originalLink = document.querySelector(`a[href*="${hiddenField.name}=${hiddenField.value}"]`)

// 			if (originalLink) {
// 				const afterConfirmAction = originalLink.dataset.afterConfirmAction

// 				if (afterConfirmAction) {
// 					const controllerName = afterConfirmAction.split("#")[0]
// 					const controllerAction = afterConfirmAction.split("#")[1]

// 					const controllerInstance = application.getControllerForElementAndIdentifier(document.body, controllerName)

// 					if (controllerInstance) controllerInstance[controllerAction]()
// 				}
// 			}
// 		}

// 		return true
// 	} else {
// 		return false
// 	}
// })

// Turbo.setConfirmMethod((message, element) => {
// 	console.log("TESTS")
// 	if (!window.confirm(message)) return false

// 	const hiddenField = element.querySelector("input[type='hidden']")
// 	if (!hiddenField) return true

// 	const originalLink = document.querySelector(`a[href*="${hiddenField.name}=${hiddenField.value}"]`)
// 	if (!originalLink) return true

// 	const afterConfirmAction = originalLink.dataset.afterConfirmAction
// 	if (!afterConfirmAction) return true

// 	const [controllerName, controllerAction] = afterConfirmAction.split("#")
// 	const controllerInstance = application.getControllerForElementAndIdentifier(document.body, controllerName)

// 	if (controllerInstance && typeof controllerInstance[controllerAction] === "function") {
// 		controllerInstance[controllerAction]()
// 	}

// 	return true
// })
